import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import * as ViewModel from '@/core/presenter/viewModel';
import { TRX_SYMBOL_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  trxAsset?: ViewModel.IAsset;
  trxBalance: string;
  trxKrw: string;
  trxPrice: number;
  onClickViewType: (viewType: HomeViewType) => void;
}

const TrxProperty = ({ trxAsset, trxBalance, trxKrw, trxPrice, onClickViewType }: IProps) => {
  return (
    <li>
      <a className="property" href="#" onClick={() => onClickViewType(HomeViewType.TRX)}>
        <div className="left">
          <div className="symbol-area">
            <div className="img icon_margin_top">
              <img src={TRX_SYMBOL_ICON_PATH} alt="trx" />
            </div>
            <div className="top asset_double_s line_height">
              <p className="fw-l body-xl asset_double_p asest_margin_right_trx">
                {trxAsset?.name} <span className="asset_symbol">TRX</span>
              </p>
              <span className="body-l asset_price asest_margin_right asset_margin_right">1 TRX = {trxPrice}원</span>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <p className="coin body-xl">{trxBalance} TRX</p>
            <span className="krw fw-b body-l">{trxKrw} 원</span>
          </div>
        </div>
      </a>
    </li>
  );
};

export default TrxProperty;
